const INVISIBLE_SORT_CHARACTERS_REGEX = /[\u200B-\u200D\uFEFF]/g;
const LEADING_SORT_NOISE_REGEX = /^[\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+/;

interface SortableLabel {
  bucket: number;
  originalText: string;
  sortText: string;
}

const getSortableLabel = (label: string): SortableLabel => {
  const originalText = (label || '').replace(INVISIBLE_SORT_CHARACTERS_REGEX, '').trim();

  if (!originalText) {
    return { bucket: 2, originalText, sortText: '' };
  }

  const sortText = originalText.replace(LEADING_SORT_NOISE_REGEX, '').trim();

  if (!sortText) {
    return { bucket: 1, originalText, sortText: originalText };
  }

  return { bucket: 0, originalText, sortText };
};

export const createLocalizedLabelComparator = (locale: string) => {
  const collator = new Intl.Collator(locale || undefined, {
    ignorePunctuation: true,
    numeric: true,
    sensitivity: 'base',
  });

  return (labelA: string, labelB: string): number => {
    const sortableA = getSortableLabel(labelA);
    const sortableB = getSortableLabel(labelB);
    const bucketComparison = sortableA.bucket - sortableB.bucket;

    if (bucketComparison !== 0) {
      return bucketComparison;
    }

    return collator.compare(sortableA.sortText, sortableB.sortText) || collator.compare(sortableA.originalText, sortableB.originalText);
  };
};
